import { render, staticRenderFns } from "./Step5RestaurantsSelection.vue?vue&type=template&id=3de66b48&scoped=true"
import script from "./Step5RestaurantsSelection.vue?vue&type=script&lang=js"
export * from "./Step5RestaurantsSelection.vue?vue&type=script&lang=js"
import style0 from "./Step5RestaurantsSelection.vue?vue&type=style&index=0&id=3de66b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de66b48",
  null
  
)

export default component.exports